<template>
    <div style="background-color: #000;">
        <div class="goTop" @click="top">
            <span>回到顶部</span>
            <i class="el-icon-arrow-up"></i>
        </div>
        <div class="contactUs">
            <span>联系我们</span>
            <div>
                <span>400-0838-028</span>
                <span>9:00-18:00 周一至周六</span>
            </div>
        </div>
        <div v-for="category in list" :key="category.id">
            <!-- 一级菜单 -->
            <div class="category-header" @click="toggleCategory(category.id)">
                <span>{{ category.name }}</span>
                <i v-if="!isCategoryOpen(category.id)" class="el-icon-plus"></i>
                <i v-else class="el-icon-minus"></i>
            </div>
            <!-- 二级菜单 -->
            <transition name="slide">
                <div v-if="isCategoryOpen(category.id)">
                    <div v-for="menu in menuList[category.id]" :key="menu.name" class="menu-item">
                        <div class="menu-header" @click.stop="toggleMenu(menu, category.id, menu.path, menu.id)">
                            <span>{{ menu.name }}</span>
                            <i v-if="menu.list" class="el-icon-arrow-right"
                                :class="{ 'arrow-down': isMenuOpen(menu) }"></i>
                        </div>

                        <!-- 三级菜单内容 -->
                        <transition name="slide">
                            <div class="store" v-if="isMenuOpen(menu) && menu.list">
                               <div v-for="item in menu.list" :key="item.id">
                                <span>
                                    {{ item.line_name }}
                                </span>
                                <div  class="info" v-for="a in item.products" :key="a.id"
                                    @click="goShow('/show', a.id, 3)">
                                    <span>{{ a.name }}</span>
                                </div>
                               </div>
                            </div>
                        </transition>
                    </div>
                    <div v-if="category.id === 'gywm'" class="menu-item">
                        <a class="menu-header admin-entry" :href="adminUrl" target="_blank"
                            rel="noopener noreferrer" @click.stop>后台管理</a>
                    </div>
                </div>
            </transition>
        </div>
        <div class="logo">
            <img src="@/assets/img/logo5.png" alt="">
        </div>
        <div class="num">
            2023 ◎ 四川省广汉市富贵车业有限公司 ALL RIGHTS RESERVED   蜀ICP备16024944号
        </div>
       
    </div>
</template>

<script>

export default {
    name: 'mobfooter',
    data() {
        return {
            // list: [
            //     {
            //         name: '电动三轮车',
            //         id: 'ddsl'
            //     },
            //     {
            //         name: '电动生活',
            //         id: 'ddsh'
            //     },
            //     {
            //         name: '富贵科技',
            //         id: 'fgkj'
            //     },
            //     {
            //         name: '服务支持',
            //         id: 'fwzc'
            //     },
            //     {
            //         name: '关于我们',
            //         id: 'gywm'
            //     }
            // ],
            activeCategory: null,
            activeMenu: null,
            fwzc: [
                {
                    name: '售后服务',
                    path: 'afterSale',
                },
                {
                    name: '使用指南',
                    path: '/guide',
                }
            ],
            gywm: [
                {
                    name: '走进富贵泉',
                    path: '/aboutUs',
                },
                {
                    name: '新闻动态',
                    path: '/news',
                },
                {
                    name: '联系我们',
                    path: '/contactUs',
                },
                {
                    name: '加入我们',
                },
                {
                    name: '荣誉资质',
                }
            ],
            offsetX: ''
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        show() {
            this.activeMenu = null
            this.activeCategory = null
        },
        '$route'() {
            this.close()
        },
    },
    computed: {
        menuList() {
            let menuList = this.$store.state.menuList
            // menuList.fwzc = this.fwzc
            // menuList.gywm = this.gywm
            return menuList
        },
        list(){
            return this.$store.state.menuList.list
        },
        adminUrl() {
            return ['127.0.0.1', 'localhost'].includes(window.location.hostname)
                ? 'http://127.0.0.1:8081/czkj'
                : 'https://api.fgqslc.com/czkj'
        }
    },
    methods: {
        top() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
        },
        toggleCategory(categoryId) {
            // 关闭当前分类时也关闭其下的菜单
            if (this.activeCategory !== categoryId) {
                this.activeMenu = null
            }
            this.activeCategory = this.activeCategory === categoryId ? null : categoryId

        },
        goPage(url, name, id) {
            if (name == 'ddsl' || name == 'ddsh') return
            // 富贵科技
            if (name == 'fgkj') {
                this.$router.push({
                    path: '/show',
                    query: {
                        id, op: 2
                    }
                })
                this.$emit('close')
                return
            }

            // // 服务支持
            if (name == 'fwzc') {
                if (url == '/afterSale' || url == '/guide') {
                    this.$router.push(url)
                    this.$emit('close')
                } else {
                    this.$router.push({
                        path: '/show',
                        query: {
                            id, op: 6
                        }
                    })
                    this.$emit('close')
                    return
                }
            }

            if (name == 'gywm') {
                console.log(url,1);
                
                if (url == '/show?id=0&op=4' || url == '/news'|| url == '/contactUs' || url=="/jobIndex") {
                    console.log(url,2);
                    this.$router.push(url)
                    this.$emit('close')
                } else {
                    this.$router.push({
                        path: '/show',
                        query: {
                            id, op: 7
                        }
                    })
                    this.$emit('close')
                    return
                }
            }

            // if (name == 'fgkj') {
            //     this.$router.push({
            //         path: '/show',
            //         query: {
            //             id, op: 2
            //         }
            //     })
            //     this.$emit('close')
            //     return
            // }
            // if (name == 'gywm' && url == '/aboutUs') {
            //     this.$router.push({
            //         path: '/show',
            //         query: {
            //             id: 0, op: 4
            //         }
            //     })
            //     return;
            // }
            if (url) {
                this.$router.push(url)
            }

        },
        goShow(url, id, op) {
            console.log(url, id, op);

            if (url) {
                this.$router.push({
                    path: url,
                    query: {
                        id, op
                    }
                })
            }
        },
        toggleMenu(menu, name, url, id) {
            if (this.activeMenu === menu) {
                this.activeMenu = null
            } else {
                this.activeMenu = menu
            }
            this.goPage(url, name, id)
        },
        isCategoryOpen(categoryId) {
            return this.activeCategory === categoryId
        },
        isMenuOpen(menu) {
            return this.activeMenu === menu
        },
        close() {
            this.activeMenu = null
            this.activeCategory = null
        }
    }
}
</script>

<style lang="scss" scoped>
.goTop {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: MiSans;
    font-weight: 400;
    font-size: 53px;
    color: #FFFFFF;
    padding: 110px 0;
    border-bottom: 2px solid #606060;

    >span {
        margin-right: 44px;
    }
}

.contactUs {
    padding: 140px 100px;
    border-bottom: 2px solid #606060;
    font-family: MiSans;
    font-weight: 400;
    font-size: 53px;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;

    >div {
        span {
            font-family: OPPOSans;
            font-weight: normal;
            font-size: 81px;
            color: #D91414;
            display: block;

            &:nth-child(2) {
                margin-top: 50px;
                font-family: OPPOSans;
                font-weight: normal;
                font-size: 53px;
                color: #FFFFFF;
            }
        }
    }
}
.logo{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 92px;
    border-bottom: 2px solid #606060;
    img{
        width: 592px;
        height: auto;
    }
}
.num{
    font-family: MiSans;
font-weight: 400;
font-size: 48px;
color: #FFFFFF;
    padding: 270px 380px 206px 130px;
}
.category-header {
    background-color: #000;
    padding: 90px;
    display: block;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    font-size: 53px;
    color: #fff;
    border-bottom: 2px solid #606060;
}


.menu-item {
    background-color: #000;
}

.menu-header {
    padding: 100px 90px 100px 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-family: MiSans;
    font-weight: 300;
    font-size: 53px;
    color: #fff;
    background-color: #222;
}

.admin-entry {
    box-sizing: border-box;
    text-decoration: none;
}

.arrow {
    display: inline-block;
    transition: transform 0.3s ease;
    width: 82px;
    height: 41px;
}

.arrow-down {
    transform: rotate(90deg);
}

.store {
    gap: 20px;
    overflow: hidden;
    background-color: #222;
    box-sizing: border-box;
    >div{
        >span{
            font-weight: 300;
        font-size: 53px;
        color: #fff;
        background-color: #222;
        padding-left: 120px;
        }
    }
}

.info {
    background-color: #222;
    display: flex;
    justify-content: center;
    padding: 40px 90px 40px 160px;
    box-sizing: border-box;
    position: relative;
    flex-direction: column;

    span {
        font-weight: 300;
        font-size: 53px;
        color: #fff;
        background-color: #222;
    }
}

/* 动画效果 */
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
    max-height: 5000px;
    /* 设置一个足够大的值 */
    opacity: 1;
}

.slide-enter,
.slide-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}

</style>
